import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from './plugins/vuetify'
import VueMobileDetection from "vue-mobile-detection";
import { createPinia, PiniaVuePlugin } from 'pinia'
import { gsap } from "gsap";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { TextPlugin } from "gsap/all";
import VueZoomer from 'vue-zoomer'
import { initializeApp } from "firebase/app";
import VueMeta from "vue-meta";
import VueGtm from '@gtm-support/vue2-gtm';
import vueAwesomeCountdown from 'vue-awesome-countdown'
import VueAnimateOnScroll from 'vue-animate-onscroll'
import VueMarqueeSlider from 'vue-marquee-slider';

import '../styleguide.css'
import '../globals.css'

const firebaseConfig = {
  apiKey: "AIzaSyASIw1x5DVBZb6nO1oNbaFjp8oCwr1GyCg",
  authDomain: "timeworx-36b8f.firebaseapp.com",
  databaseURL: "https://timeworx-36b8f-default-rtdb.firebaseio.com",
  projectId: "timeworx-36b8f",
  storageBucket: "timeworx-36b8f.appspot.com",
  messagingSenderId: "851077055686",
  appId: "1:851077055686:web:55233ab1d81308c896c3c7",
  measurementId: "G-0Z4QXT93H6"
};

initializeApp(firebaseConfig);

gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(TextPlugin);

Vue.config.productionTip = false;

Vue.use(VueMobileDetection);
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
Vue.use(VueZoomer);
Vue.use(VueMeta);
Vue.use(vueAwesomeCountdown, 'vac')

Vue.use(VueGtm, {
  id: 'GTM-WPKSLD3H',
  // queryParams: {
  //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview: 'env-4',
  //   gtm_cookies_win: 'x',
  // },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  // nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

Vue.use(VueAnimateOnScroll)
Vue.use(VueMarqueeSlider)

new Vue({
  render: h => h(App),
  vuetify,
  VueMobileDetection,
  router,
  pinia
}).$mount("#app");